import moment from 'moment';
import React, { Component } from 'react';
import queryString from 'query-string';
import { Button, Table, Input, message, Modal, Popconfirm, Alert } from 'antd';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import columns from './columns';
import xfetch from '../../../../xfetch';
import { backendErrorTip } from '../../../../utils';
import UpdateForm from './UpdateForm';
import s from './style.css';

const { Search } = Input;

@withStyles(s)
export default class Word extends Component {
  constructor(props) {
    super(props);
    this.q = {
      page_size: 10,
      page: 1,
      status: 'on',
    };
    this.baseApi = `${window.G.backendApi}/word/sensitive_word/`;
  }
  state = {
    data: {},
    item: {},
    loading: true,
    modals: {
      updateForm: { title: '', visible: false },
    },
    selectedRowKeys: [],
  };
  componentDidMount() {
    this.query();
  }
  onTableChange = pagination => {
    const { current } = pagination;
    this.q.page = current;
    this.query();
  };
  onSelectChange = selectedRowKeys => this.setState({ selectedRowKeys });
  setModals({ key, title, item = {}, visible }) {
    this.setState({
      modals: {
        ...this.state.modals,
        [key]: {
          ...this.state.modals[key],
          title,
          visible,
        },
      },
      item,
    });
  }
  query = () => {
    const api = `${this.baseApi}?${queryString.stringify(this.q)}`;
    xfetch(api).then(({ error, result }) => {
      this.setState({
        loading: false,
      });
      if (error) {
        return;
      }
      this.setState({
        data: result,
      });
    });
  };
  handleSearch = search => {
    this.q.search = search;
    this.q.page = 1;
    this.query();
  };
  updateItem = () => {
    let title;
    const { item } = this.state;
    const { id } = item;

    this.updateForm.validateFields((err, values) => {
      if (err) {
        return;
      }
      const body = {
        ...values,
        timeout: moment(values.timeout).format('YYYY-MM-DD 00:00:00'),
      };

      if (id) {
        title = '编辑敏感词';
        xfetch(`${this.baseApi}${id}/`, {
          body,
          method: 'PATCH',
        }).then(({ error }) => {
          if (error) {
            message.error('编辑失败');
            return;
          }
          this.setModals({ key: 'updateForm', title, visible: false });
          message.success('编辑成功');
          this.query();
        });
      } else {
        title = '添加敏感词';
        xfetch(this.baseApi, {
          body: {
            ...body,
            status: 'on',
          },
          method: 'POST',
        }).then(({ error }) => {
          if (error) {
            message.error('添加失败');
            return;
          }
          this.setModals({ key: 'updateForm', title, visible: false });
          message.success('添加成功');
          this.query();
        });
      }
    });
  };
  deleteItem = async id => {
    await xfetch(`${this.baseApi}${id}/`, {
      method: 'PATCH',
      body: { status: 'deleted' },
    });
    this.query();
  };
  batchDelete = async () => {
    const { selectedRowKeys: ids } = this.state;
    const { error } = await xfetch(
      `${this.baseApi}batch_delete/?real_delete=0&ids=${JSON.stringify(ids)}`,
      {
        method: 'DELETE',
      },
    );
    if (error) {
      backendErrorTip(error);
      return;
    }
    this.query();
  };
  refreshCache = async () => {
    const { error } = await xfetch(`${this.baseApi}refresh/`);
    if (error) {
      backendErrorTip(error);
      return;
    }
    message.success('敏感词配置已生效');
  };
  render() {
    const {
      data: { results, count = 0 },
      loading,
      modals: { updateForm },
      selectedRowKeys,
      item,
    } = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };
    const pagination = {
      pageSize: 10,
      total: count,
      showTotal: t => `共 ${t} 条`,
      current: this.q.page,
    };
    return (
      <div className={s.wrap}>
        <Alert
          message="提示： 修改敏感词后1小时内生效， 如需立刻生效，请点击「刷新缓存」按钮。"
          type="warning"
          closable
          style={{ marginBottom: 15 }}
        />
        <div className={s.toolbar}>
          <div className={s.toolbarLeft}>
            <Search
              placeholder="输入关键词搜索"
              onSearch={this.handleSearch}
              enterButton="搜索"
              style={{ width: 260 }}
            />
          </div>
          <div className={s.toolbarRight}>
            <Button
              type="primary"
              onClick={() =>
                this.setModals({
                  key: 'updateForm',
                  title: '添加敏感词',
                  visible: true,
                })
              }
            >
              添加
            </Button>
            <Button onClick={this.refreshCache}>刷新缓存</Button>
            {selectedRowKeys.length ? (
              <Popconfirm
                title="确认批量删除？"
                placement="left"
                okText="确认"
                cancelText="取消"
                onConfirm={this.batchDelete}
              >
                <Button type="danger">删除</Button>
              </Popconfirm>
            ) : (
              <Button type="danger" disabled>
                删除
              </Button>
            )}
          </div>
        </div>
        <div className={s.table}>
          <Table
            rowKey="id"
            loading={loading}
            dataSource={results}
            columns={columns(this, s)}
            rowSelection={rowSelection}
            pagination={pagination}
            onChange={this.onTableChange}
          />
        </div>
        <Modal
          title={updateForm.title}
          visible={updateForm.visible}
          width={550}
          destroyOnClose
          maskClosable={false}
          onOk={this.updateItem}
          onCancel={() =>
            this.setModals({
              key: 'updateForm',
              title: '',
              visible: false,
            })
          }
          className={s.updateGroupForm}
        >
          <UpdateForm
            ref={x => {
              this.updateForm = x;
            }}
            item={item}
          />
        </Modal>
      </div>
    );
  }
}
